// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var EIntegrityCheckError;
(function (EIntegrityCheckError) {
    EIntegrityCheckError["IO_ERROR"] = "io-error";
    EIntegrityCheckError["HASH_MISSMATCH"] = "hash-mismatch";
    EIntegrityCheckError["HASH_COMPUTING_ERROR"] = "hash-computing-error";
})(EIntegrityCheckError || (EIntegrityCheckError = {}));
export var IAudienceSelection;
(function (IAudienceSelection) {
    IAudienceSelection["ALL_USERS"] = "ALL_USERS";
    IAudienceSelection["NOT_VOTED"] = "NOT_VOTED";
    IAudienceSelection["VOTED"] = "VOTED";
    IAudienceSelection["SELECTED"] = "SELECTED";
})(IAudienceSelection || (IAudienceSelection = {}));
export var ETemplateType;
(function (ETemplateType) {
    ETemplateType["CREDENTIALS"] = "CREDENTIALS";
    ETemplateType["PARTICIPATION_REPORT"] = "PARTICIPATION_REPORT";
    ETemplateType["OTP"] = "OTP";
    ETemplateType["TALLY_REPORT"] = "TALLY_REPORT";
    ETemplateType["BALLOT_RECEIPT"] = "BALLOT_RECEIPT";
    ETemplateType["VOTE_RECEIPT"] = "VOTE_RECEIPT";
    ETemplateType["MANUAL_VERIFICATION"] = "MANUAL_VERIFICATION";
    ETemplateType["ACTIVITY_LOGS"] = "ACTIVITY_LOGS";
    ETemplateType["INITIALIZATION_REPORT"] = "INITIALIZATION_REPORT";
    ETemplateType["STATUS"] = "STATUS";
    ETemplateType["ELECTORAL_RESULTS"] = "ELECTORAL_RESULTS";
    ETemplateType["TRANSMISSION_REPORT"] = "TRANSMISSION_REPORT";
    ETemplateType["STATISTICAL_REPORT"] = "STATISTICAL_REPORT";
    ETemplateType["AUDIT_LOGS"] = "AUDIT_LOGS";
    ETemplateType["OVCS_INFORMATION"] = "OVCS_INFORMATION";
    ETemplateType["OV_TURNOUT_PERCENTAGE"] = "OV_TURNOUT_PERCENTAGE";
    ETemplateType["OVCS_EVENTS"] = "OVCS_EVENTS";
    ETemplateType["OVCS_STATISTICS"] = "OVCS_STATISTICS";
    ETemplateType["OV_TURNOUT_PER_ABOARD_STATUS_SEX"] = "OV_TURNOUT_PER_ABOARD_STATUS_SEX";
    ETemplateType["OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE"] = "OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE";
    ETemplateType["LIST_OF_OVERSEAS_VOTERS"] = "LIST_OF_OVERSEAS_VOTERS";
    ETemplateType["OV_PRE_ENROLLED_APPROVED"] = "OV_PRE_ENROLLED_APPROVED";
    ETemplateType["PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION"] = "PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION";
    ETemplateType["PRE_ENROLLED_OV_BUT_DISAPPROVED"] = "PRE_ENROLLED_OV_BUT_DISAPPROVED";
    ETemplateType["OV_NOT_YET_PRE_ENROLLED_LIST"] = "OV_NOT_YET_PRE_ENROLLED_LIST";
    ETemplateType["OV_WITH_VOTING_STATUS"] = "OV_WITH_VOTING_STATUS";
    ETemplateType["OV_WHO_VOTED"] = "OV_WHO_VOTED";
    ETemplateType["OV_NOT_YET_PRE_ENROLLED_NUMBER"] = "OV_NOT_YET_PRE_ENROLLED_NUMBER";
    ETemplateType["BALLOT_IMAGES"] = "BALLOT_IMAGES";
})(ETemplateType || (ETemplateType = {}));
export var ITemplateMethod;
(function (ITemplateMethod) {
    ITemplateMethod["EMAIL"] = "EMAIL";
    ITemplateMethod["SMS"] = "SMS";
    ITemplateMethod["DOCUMENT"] = "DOCUMENT";
})(ITemplateMethod || (ITemplateMethod = {}));
